import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  numCustomerClaimsFromModel,
  validateNumCustomerClaimsCondition,
  type NumCustomerClaimsState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const NUM_CUSTOMER_CLAIMS = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NumCustomerClaimsState>
  >,
): ConditionType<NumCustomerClaimsState, Condition.NumCustomerClaims> => ({
  name: "Number of previous customer claims",
  description(state) {
    if (!state.claimOption) {
      return "The total number of claims this customer has previously made";
    }
    return `Number of previous claims ${state.claimOption.toLowerCase()} ${state.numClaims}`;
  },
  Details(props: ConditionTypeDetailsProps<NumCustomerClaimsState>) {
    return React.createElement(Details, props);
  },
  empty: { numClaims: (0).toFixed(0), claimOption: null },
  fromModel(model) {
    return numCustomerClaimsFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NUM_CUSTOMER_CLAIMS,
      numClaims: +state.numClaims,
      numClaimsOption: state.claimOption,
    };
  },
  valid(state) {
    return validateNumCustomerClaimsCondition(state).valid;
  },
});

export { type NumCustomerClaimsState } from "@redotech/redo-model/return-flow/condition-validate";
